import { Card, CardContent, CardHeader, type CardProps } from '@mui/material';
import { type ReactNode } from 'react';
import { colors, radius, densitySpacing } from '@/theme/tokens';
import { usePreferencesStore } from '@/stores';

interface AppCardProps extends Omit<CardProps, 'title'> {
  children?: ReactNode;
  title?: ReactNode;
  subtitle?: string;
  action?: ReactNode;
  noPadding?: boolean;
}

export function AppCard({
  children,
  title,
  subtitle,
  action,
  noPadding = false,
  sx,
  ...props
}: AppCardProps) {
  const density = usePreferencesStore((s) => s.density);
  const cp = densitySpacing[density].cardPadding;
  return (
    <Card
      sx={{
        backgroundColor: colors.surface,
        border: `1px solid ${colors.border}`,
        borderRadius: radius.lg,
        boxShadow: '0 2px 4px rgba(31, 41, 51, 0.06)',
        overflow: 'hidden',
        ...sx,
      }}
      {...props}
    >
      {title && (
        <CardHeader
          title={title}
          subheader={subtitle}
          action={action}
          sx={{
            padding: noPadding ? 0 : cp,
            paddingBottom: noPadding ? 0 : undefined,
            '& .MuiCardHeader-title': {
              fontSize: '18px',
              fontWeight: 600,
              color: colors.textPrimary,
            },
            '& .MuiCardHeader-subheader': {
              fontSize: '14px',
              color: colors.textMuted,
              marginTop: '4px',
            },
          }}
        />
      )}
      <CardContent
        sx={{
          padding: noPadding ? 0 : cp,
          paddingTop: title ? 0 : noPadding ? 0 : cp,
          '&:last-child': {
            paddingBottom: noPadding ? 0 : cp,
          },
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
}
